var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullMedCover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 225 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "carousel",
    x: 0,
    y: 0,
    width: 225,
    height: 20.1,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 225,
    height: 20.1
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.725,5.473l-6.086,0l-0.69,3.362l5.551,0l-0.965,4.404l-5.551,0l-1.355,6.515l-5.629,0l3.948,-18.685l11.715,0l-0.938,4.404Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.368,19.754l-5.63,0c0.061,-1.007 0.131,-1.737 0.209,-2.189l-0.052,0c-0.782,0.843 -1.607,1.473 -2.476,1.89c-0.869,0.417 -1.733,0.625 -2.593,0.625c-2.172,0 -3.258,-1.094 -3.258,-3.284c0,-0.651 0.096,-1.407 0.287,-2.267l1.72,-8.118l5.551,0l-1.551,7.232c-0.147,0.591 -0.221,1.082 -0.221,1.473c0,0.173 0.063,0.327 0.189,0.462c0.126,0.135 0.323,0.202 0.593,0.202c0.634,0 1.207,-0.323 1.72,-0.971c0.512,-0.647 0.864,-1.444 1.055,-2.391l1.251,-6.007l5.551,0l-1.785,8.379c-0.165,0.782 -0.3,1.646 -0.404,2.593c-0.104,0.947 -0.156,1.737 -0.156,2.371Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.16,19.754l-5.551,0l4.183,-19.754l5.551,0l-4.183,19.754Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.382,19.754l-5.551,0l4.183,-19.754l5.551,0l-4.183,19.754Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.545,19.754l-5.551,0l2.333,-10.997l0.612,-2.802l-0.104,0l-0.964,2.319l-5.265,11.48l-5.173,0l-0.664,-10.828c-0.053,-0.73 -0.079,-1.72 -0.079,-2.971l-0.117,0c-0.252,1.92 -0.543,3.675 -0.873,5.264l-1.811,8.535l-4.991,0l3.948,-18.685l7.897,0l0.651,11.167c0,0.564 -0.021,1.151 -0.065,1.759l0.078,0c0.148,-0.417 0.3,-0.854 0.457,-1.31c0.156,-0.456 0.317,-0.866 0.482,-1.231l4.56,-10.385l8.601,0l-3.962,18.685Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.371,10.073c0,1.529 -0.701,2.667 -2.104,3.414c-1.403,0.747 -3.564,1.164 -6.483,1.251l0,0.104c0,0.504 0.213,0.897 0.639,1.179c0.425,0.282 0.994,0.424 1.707,0.424c0.634,0 1.396,-0.109 2.286,-0.326c0.891,-0.217 1.623,-0.474 2.196,-0.769l-0.769,3.636c-0.677,0.321 -1.5,0.584 -2.469,0.788c-0.969,0.204 -1.935,0.306 -2.899,0.306c-1.868,0 -3.336,-0.495 -4.405,-1.485c-1.068,-0.991 -1.602,-2.346 -1.602,-4.066c0,-1.564 0.367,-3.006 1.101,-4.326c0.734,-1.32 1.746,-2.337 3.036,-3.049c1.29,-0.713 2.777,-1.069 4.463,-1.069c1.685,0 2.99,0.343 3.915,1.03c0.926,0.686 1.388,1.672 1.388,2.958Zm-5.121,-0.026c0,-0.191 -0.058,-0.365 -0.176,-0.522c-0.117,-0.156 -0.323,-0.234 -0.619,-0.234c-0.582,0 -1.083,0.221 -1.505,0.664c-0.421,0.443 -0.706,1.069 -0.853,1.877c0.981,0 1.752,-0.148 2.313,-0.443c0.56,-0.296 0.84,-0.743 0.84,-1.342Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.861,19.754l-5.499,0c0,-0.278 0.066,-1.068 0.196,-2.371l-0.052,0c-1.295,1.798 -2.78,2.697 -4.457,2.697c-1.294,0 -2.304,-0.452 -3.029,-1.355c-0.726,-0.903 -1.088,-2.163 -1.088,-3.779c0,-1.729 0.384,-3.268 1.153,-4.619c0.769,-1.351 1.85,-2.396 3.244,-3.134c1.395,-0.738 2.952,-1.108 4.672,-1.108c0.121,0 0.423,0.013 0.905,0.039c0.483,0.026 0.741,0.053 0.776,0.079l1.342,-6.203l5.525,0l-3.18,15.063c-0.139,0.617 -0.258,1.399 -0.358,2.346c-0.1,0.947 -0.15,1.729 -0.15,2.345Zm-3.87,-10.059c-0.313,-0.052 -0.586,-0.078 -0.821,-0.078c-0.695,0 -1.316,0.199 -1.863,0.599c-0.547,0.4 -0.993,1.006 -1.336,1.818c-0.343,0.812 -0.514,1.605 -0.514,2.378c0,0.521 0.117,0.919 0.351,1.192c0.235,0.274 0.517,0.411 0.847,0.411c0.6,0 1.145,-0.35 1.636,-1.049c0.491,-0.7 0.888,-1.718 1.192,-3.056l0.508,-2.215Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.341,2.671c0,0.826 -0.302,1.494 -0.905,2.007c-0.604,0.513 -1.397,0.769 -2.378,0.769c-0.869,0 -1.577,-0.228 -2.124,-0.684c-0.548,-0.456 -0.821,-1.028 -0.821,-1.714c0,-0.834 0.304,-1.509 0.912,-2.026c0.608,-0.517 1.407,-0.775 2.397,-0.775c0.852,0 1.551,0.223 2.098,0.671c0.548,0.447 0.821,1.031 0.821,1.752Zm-3.792,17.083l-5.551,0l2.828,-13.343l5.551,0l-2.828,13.343Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.417,10.711c-0.573,-0.373 -1.337,-0.56 -2.293,-0.56c-1.008,0 -1.861,0.36 -2.561,1.081c-0.699,0.721 -1.049,1.612 -1.049,2.672c0,1.407 0.739,2.111 2.216,2.111c0.417,0 0.881,-0.063 1.394,-0.189c0.512,-0.126 0.973,-0.302 1.381,-0.528l-0.769,3.792c-0.625,0.33 -1.309,0.578 -2.052,0.743c-0.743,0.165 -1.457,0.247 -2.143,0.247c-1.729,0 -3.087,-0.488 -4.073,-1.466c-0.986,-0.977 -1.479,-2.321 -1.479,-4.033c0,-1.555 0.376,-2.988 1.128,-4.3c0.751,-1.312 1.796,-2.339 3.133,-3.082c1.338,-0.742 2.846,-1.114 4.522,-1.114c1.425,0 2.606,0.235 3.544,0.704l-0.899,3.922Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.572,19.754l-5.499,0c0,-0.278 0.065,-1.068 0.195,-2.371l-0.052,0c-1.32,1.798 -2.806,2.697 -4.456,2.697c-1.312,0 -2.326,-0.456 -3.043,-1.368c-0.716,-0.912 -1.075,-2.193 -1.075,-3.844c0,-1.181 0.228,-2.346 0.684,-3.492c0.456,-1.147 1.086,-2.103 1.89,-2.867c0.803,-0.764 1.789,-1.36 2.958,-1.785c1.168,-0.426 2.517,-0.639 4.046,-0.639c2.093,0 4.291,0.27 6.593,0.808l-1.733,8.17c-0.139,0.617 -0.258,1.399 -0.358,2.346c-0.1,0.947 -0.15,1.729 -0.15,2.345Zm-3.87,-10.059c-0.209,-0.052 -0.474,-0.078 -0.795,-0.078c-0.695,0 -1.32,0.199 -1.876,0.599c-0.556,0.4 -1.006,0.999 -1.349,1.798c-0.343,0.799 -0.515,1.599 -0.515,2.398c0,0.521 0.113,0.919 0.339,1.192c0.226,0.274 0.504,0.411 0.834,0.411c0.625,0 1.186,-0.354 1.681,-1.062c0.495,-0.708 0.886,-1.723 1.173,-3.043l0.508,-2.215Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.26,19.754l-5.551,0l4.183,-19.754l5.551,0l-4.183,19.754Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.26,6.541c-0.53,-0.252 -1.112,-0.464 -1.747,-0.638c-0.634,-0.174 -1.403,-0.261 -2.306,-0.261c-1.181,0 -2.204,0.254 -3.069,0.763c-0.864,0.508 -1.529,1.216 -1.993,2.124c-0.465,0.907 -0.698,1.917 -0.698,3.029c0,1.164 0.352,2.074 1.056,2.73c0.704,0.656 1.72,0.984 3.049,0.984c0.591,0 1.251,-0.096 1.981,-0.287c0.729,-0.191 1.437,-0.451 2.124,-0.782l-1.121,5.147c-1.355,0.487 -2.849,0.73 -4.482,0.73c-2.746,0 -4.863,-0.708 -6.353,-2.124c-1.49,-1.416 -2.235,-3.379 -2.235,-5.89c0,-2.25 0.509,-4.254 1.525,-6.013c1.016,-1.759 2.439,-3.082 4.267,-3.968c1.829,-0.886 3.973,-1.329 6.431,-1.329c0.791,0 1.625,0.063 2.502,0.189c0.877,0.126 1.616,0.276 2.215,0.449l-1.146,5.147Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.776,19.754l-5.499,0c0,-0.278 0.065,-1.068 0.195,-2.371l-0.052,0c-1.32,1.798 -2.806,2.697 -4.456,2.697c-1.312,0 -2.326,-0.456 -3.043,-1.368c-0.717,-0.912 -1.075,-2.193 -1.075,-3.844c0,-1.181 0.228,-2.346 0.684,-3.492c0.456,-1.147 1.086,-2.103 1.889,-2.867c0.804,-0.764 1.79,-1.36 2.958,-1.785c1.169,-0.426 2.517,-0.639 4.046,-0.639c2.094,0 4.292,0.27 6.594,0.808l-1.733,8.17c-0.139,0.617 -0.259,1.399 -0.359,2.346c-0.099,0.947 -0.149,1.729 -0.149,2.345Zm-3.87,-10.059c-0.209,-0.052 -0.474,-0.078 -0.795,-0.078c-0.695,0 -1.321,0.199 -1.877,0.599c-0.556,0.4 -1.005,0.999 -1.348,1.798c-0.344,0.799 -0.515,1.599 -0.515,2.398c0,0.521 0.113,0.919 0.339,1.192c0.226,0.274 0.504,0.411 0.834,0.411c0.625,0 1.185,-0.354 1.681,-1.062c0.495,-0.708 0.886,-1.723 1.172,-3.043l0.509,-2.215Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.536,11.167l-0.026,0c-0.434,-0.217 -0.908,-0.326 -1.42,-0.326c-0.904,0 -1.636,0.261 -2.196,0.782c-0.56,0.522 -0.984,1.416 -1.271,2.685l-1.146,5.446l-5.551,0l1.811,-8.509c0.426,-1.98 0.704,-3.592 0.834,-4.834l5.46,0c-0.096,0.843 -0.209,1.698 -0.339,2.567l0.052,0c0.513,-0.99 1.066,-1.72 1.661,-2.189c0.596,-0.469 1.288,-0.704 2.079,-0.704c0.33,0 0.721,0.057 1.173,0.17l-1.121,4.912Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,10.073c0,1.529 -0.701,2.667 -2.104,3.414c-1.403,0.747 -3.564,1.164 -6.483,1.251l0,0.104c0,0.504 0.213,0.897 0.638,1.179c0.426,0.282 0.995,0.424 1.707,0.424c0.634,0 1.397,-0.109 2.287,-0.326c0.891,-0.217 1.623,-0.474 2.196,-0.769l-0.769,3.636c-0.678,0.321 -1.501,0.584 -2.469,0.788c-0.969,0.204 -1.935,0.306 -2.9,0.306c-1.867,0 -3.335,-0.495 -4.404,-1.485c-1.068,-0.991 -1.603,-2.346 -1.603,-4.066c0,-1.564 0.367,-3.006 1.101,-4.326c0.734,-1.32 1.747,-2.337 3.037,-3.049c1.29,-0.713 2.777,-1.069 4.463,-1.069c1.685,0 2.99,0.343 3.915,1.03c0.925,0.686 1.388,1.672 1.388,2.958Zm-5.121,-0.026c0,-0.191 -0.059,-0.365 -0.176,-0.522c-0.117,-0.156 -0.324,-0.234 -0.619,-0.234c-0.582,0 -1.084,0.221 -1.505,0.664c-0.421,0.443 -0.706,1.069 -0.853,1.877c0.981,0 1.752,-0.148 2.312,-0.443c0.561,-0.296 0.841,-0.743 0.841,-1.342Z",
    style: {
      fill: "#104e21",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullMedCover);
export default __webpack_public_path__ + "static/media/full-med-cover.244f463e25dd358ab9203bedbdb3e403.svg";
export { ForwardRef as ReactComponent };